const cookiesbakker = [...document.querySelectorAll('.js-cookiesbakker')];

cookiesbakker.map(cookiesbanner => {

    /**
     * Buttons
     * @type {Element | SVGSymbolElement | SVGMetadataElement | SVGUseElement | SVGAnimateElement | SVGFEImageElement | SVGPathElement | SVGViewElement | SVGFEConvolveMatrixElement | SVGFECompositeElement | SVGEllipseElement | SVGFEOffsetElement | SVGTextElement | SVGDefsElement | SVGFETurbulenceElement | SVGImageElement | SVGFEFuncGElement | SVGMPathElement | SVGTSpanElement | SVGClipPathElement | SVGLinearGradientElement | SVGFEFuncRElement | SVGScriptElement | SVGFEColorMatrixElement | SVGFEComponentTransferElement | SVGStopElement | SVGMarkerElement | SVGFEMorphologyElement | SVGFEMergeElement | SVGFEPointLightElement | SVGForeignObjectElement | SVGFEDiffuseLightingElement | SVGStyleElement | SVGFEBlendElement | SVGCircleElement | SVGPolylineElement | SVGDescElement | SVGFESpecularLightingElement | SVGLineElement | SVGFESpotLightElement | SVGFETileElement | SVGPatternElement | SVGTitleElement | SVGSwitchElement | SVGRectElement | SVGFEDisplacementMapElement | SVGFEFuncAElement | SVGFEFuncBElement | SVGFEMergeNodeElement | SVGTextPathElement | SVGFEFloodElement | SVGMaskElement | SVGAElement | SVGAnimateTransformElement | SVGSetElement | SVGSVGElement | SVGAnimateMotionElement | SVGGElement | SVGFEDistantLightElement | SVGFEDropShadowElement | SVGRadialGradientElement | SVGFilterElement | SVGPolygonElement | SVGFEGaussianBlurElement | HTMLSelectElement | HTMLLegendElement | HTMLElement | HTMLTableCaptionElement | HTMLTextAreaElement | HTMLModElement | HTMLHRElement | HTMLOutputElement | HTMLEmbedElement | HTMLCanvasElement | HTMLFrameSetElement | HTMLMarqueeElement | HTMLScriptElement | HTMLInputElement | HTMLMetaElement | HTMLStyleElement | HTMLObjectElement | HTMLTemplateElement | HTMLBRElement | HTMLAudioElement | HTMLIFrameElement | HTMLMapElement | HTMLTableElement | HTMLAnchorElement | HTMLMenuElement | HTMLPictureElement | HTMLParagraphElement | HTMLTableCellElement | HTMLTableSectionElement | HTMLQuoteElement | HTMLProgressElement | HTMLLIElement | HTMLTableRowElement | HTMLFontElement | HTMLSpanElement | HTMLTableColElement | HTMLOptGroupElement | HTMLDataElement | HTMLDListElement | HTMLFieldSetElement | HTMLSourceElement | HTMLBodyElement | HTMLDirectoryElement | HTMLDivElement | HTMLUListElement | HTMLDetailsElement | HTMLHtmlElement | HTMLAreaElement | HTMLPreElement | HTMLMeterElement | HTMLFrameElement | HTMLOptionElement | HTMLImageElement | HTMLLinkElement | HTMLHeadingElement | HTMLSlotElement | HTMLVideoElement | HTMLTitleElement | HTMLButtonElement | HTMLHeadElement | HTMLDialogElement | HTMLParamElement | HTMLTrackElement | HTMLOListElement | HTMLDataListElement | HTMLLabelElement | HTMLFormElement | HTMLTimeElement | HTMLBaseElement}
     */
    const acceptAllButton = cookiesbanner.querySelector('.js-cookiesbakker-all');
    const acceptSelectedButton = cookiesbanner.querySelector('.js-cookiesbakker-selected');
    const acceptNoneButton = cookiesbanner.querySelector('.js-cookiesbakker-none');

    if(acceptAllButton) {
        acceptAllButton.addEventListener('click', () => {
            consentGranted('ad_storage');
            consentGranted('ad_user_data');
            consentGranted('ad_personalization');
            consentGranted('analytics_storage');
            closeCookiebanner();
        });
    }

    if(acceptSelectedButton) {
        acceptSelectedButton.addEventListener('click', () => {
            updateGrantedConsents();
        });
    }

    if(acceptNoneButton) {
        acceptNoneButton.addEventListener('click', () => {
            closeCookiebanner();
        });
    }

    /**
     * Cookie functions
     * @param cname
     * @returns {string}
     */
    const getCookie = cname => {
        const name = cname + "=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');
        for(const cookie of ca) {
            let c = cookie.trim();
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    };

    const setCookie = (cname, cvalue, exdays) => {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        const expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    };

    if(!getCookie('cookiesbakker')) {
        cookiesbanner.setAttribute('data-active', '');
        document.body.classList.add('locked');
    }


    const closeCookiebanner = () => {
        cookiesbanner.removeAttribute('data-active');
        setCookie('cookiesbakker', 1, 14);
        document.body.classList.remove('locked');

    }

    const updateGrantedConsents = () => {
        const choices = [...cookiesbanner.querySelectorAll('input[type="checkbox"]')];

        choices.map(choice => {
            if (choice.checked) {
                if (choice.value === 'marketing') {
                    consentGranted('ad_storage');
                    consentGranted('ad_user_data');
                    consentGranted('ad_personalization');
                } else if (choice.value === 'statistics') {
                    consentGranted('analytics_storage');
                }
            }
        });

        closeCookiebanner();
    }

    /**
     * Possible types are:
     * ad_storage, ad_user_data, ad_personalization
     * analytics_storage
     * @param type
     */
    const consentGranted = type => {
        gtag('consent', 'update', {
            [type]: 'granted'
        });
    }

});
